import i18n from "i18n";
const BackendTypes = {
  backendTypes: [
    {
      value: "fs-1",
      // Read lazily, so the label is translated when it is displayed and not when the module loads.
      get label() {
        return i18n.t("archive_backend_config_form.file_system", { ns: "enterprise_archive" });
      }
    },
    { value: "s3-1", label: "Amazon S3" },
    { value: "gcs-1", label: "Google Cloud Storage" },
    { value: "abs-1", label: "Azure Blob" }
  ],
  getBackendType(backendType) {
    return this.backendTypes.filter((t) => t.value === backendType)[0];
  }
};
export default BackendTypes;
